import { orange, red } from '@mui/material/colors';
import { FieldErrors } from 'react-hook-form';
import {
  getTrancheOpenRequiredFields,
  TrancheFormSection,
  trancheFormSectionFields,
} from '../types';
import { TrancheFormInput } from '../useTrancheForm';

export const TrancheDotColor = {
  Draft: orange[800],
  Error: red[500],
  Open: '#56B26C',
  Closed: red[700],
} as const;

export type TrancheDotColor =
  (typeof TrancheDotColor)[keyof typeof TrancheDotColor];

export const getSectionDotColor = (
  section: TrancheFormSection,
  errors: FieldErrors<TrancheFormInput>,
  isPublishable: boolean | null,
  usesDealDocumentation: boolean,
): TrancheDotColor | undefined => {
  if (trancheFormSectionFields[section].some((field) => field in errors)) {
    return TrancheDotColor.Error;
  }

  if (isPublishable === false) {
    const openRequiredFields = getTrancheOpenRequiredFields(
      usesDealDocumentation,
    );
    if (
      trancheFormSectionFields[section].some((field) =>
        openRequiredFields.has(field),
      )
    ) {
      return TrancheDotColor.Draft;
    }
  }

  return undefined;
};
